<template>
  <div class="GroupCourseLessonElementFilterBar">
      <div class="row vertical-align margin-top-4Perc margin-bottom-2Perc">
        <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
            Group Course(s)
        </div>    
        <div class="col-md-2 col-lg-2">
            <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                    <select class="form-control" v-model="selectedGroupCourseObj">
                      <option value=-1 disabled>Select</option>
                      <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
          Cohort(s)
        </div>    
        <div class="col-md-2 col-lg-2">
            <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                    <select class="form-control" v-model="selectedCohortObj" :disabled="selectedGroupCourseObj === -1">
                    <option value='-1' disabled>Select</option>
                    <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                  </select> 
                </div>
            </div>
        </div>
        <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
          User Subset
        </div>    
        <div class="col-md-2 col-lg-2">
          <div class="form-group">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                  <select class="form-control" v-model="selectedUserSubset">
                    <option value=-1 disabled>Select</option>
                    <option :value=constants.UserSubsetTypeEnum.FacilitatorOnly>Facilitator Only</option>
                    <option :value=constants.UserSubsetTypeEnum.ParticipantsOnly>Participants Only</option>
                    <option :value=constants.UserSubsetTypeEnum.Both>Both</option>
                </select>
              </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3">
          <div class="checkbox text-align-center">
            <label>
              <input type="checkbox" v-model="getExcludeInternalUsersValue">Exclude Internal Users
            </label>
          </div>
        </div>
      </div> 
      
      <div class="row vertical-align margin-top-4Perc margin-bottom-2Perc">
        <div class="col-md-1 col-lg-1"></div>  
        <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
            Lesson
        </div>    
        <div class="col-md-3 col-lg-3">
            <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px" id="vueMultiSelect">
                    <vue-multi-select
                      :disabled="selectedGroupCourseObj === -1 || selectedCohortObj === -1"
                      search
                      :filters="lessonFilters"
                      btnClass="cssClass"
                      v-model="selectedLessonForProcessingValue"
                      :btnLabel="lessonBtnLabel"
                      :options="lessonOptions"
                      :selectOptions="lessonDataToPass" />
                </div>
            </div>
        </div>
        <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
          Element
        </div>    
        <div class="col-md-3 col-lg-3">
            <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px" id="vueMultiSelect">
                  <vue-multi-select
                    :disabled="selectedGroupCourseObj === -1 || selectedCohortObj === -1 || elementDataToPass.length === 0"
                    search
                    :filters="elementFilters"
                    btnClass="cssClass"
                    v-model="selectedElementForProcessingValue"
                    :btnLabel="elementBtnLabel"
                    :options="elementOptions"
                    :selectOptions="elementDataToPass" />
                </div>
            </div>
        </div>
        <div class="col-md-2 col-lg-2">
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
        </div>
        <div class="col-md-1 col-lg-1"></div>  
      </div>  

      <!-- <div class="row vertical-align margin-top-4Perc margin-bottom-4Perc">
        <div class="col-md-5 col-lg-5"></div>    
        <div class="col-md-1 col-lg-1" v-if="showView">
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, false)">View</button>
        </div>
        <div class="col-md-2 col-lg-2">
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
        </div>
        <div class="col-md-5 col-lg-5"></div>
      </div> -->
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
  </div>    
</template>

<script>
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { cohortService } from '@/server-util/cohort-service'
import { courseService } from '@/server-util/course-service'
import AlertBox from '@/components/AlertOverlay'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'
import Loader from '@/components/dashboard/Loader'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import forEach from 'lodash/forEach'
export default {
  props: ['showExport', 'showView'],
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      constants: constants,
      selectedUserSubset: constants.UserSubsetTypeEnum.Both,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupCourseObj: -1,
      selectedCohortObj: -1,
      associatedCohortList: [],
      lessonList: [],
      elementList: [],
      lessonBtnLabel: selectedLessonForProcessing => selectedLessonForProcessing.length > 0 ? selectedLessonForProcessing.length === 1 ? '1 Lesson is selected' : selectedLessonForProcessing.length + ' Lessons are selected' : 'Select Single/Multiple Lessons',
      selectedLessonForProcessing: [],
      lessonDataToPass: [],
      lessonOptions: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      lessonFilters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }],
      elementBtnLabel: selectedElementForProcessing => selectedElementForProcessing.length > 0 ? selectedElementForProcessing.length === 1 ? '1 Element is selected' : selectedElementForProcessing.length + ' Elements are selected' : 'Select Single/Multiple Elements',
      selectedElementForProcessing: [],
      elementDataToPass: [],
      elementOptions: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      elementFilters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }],
      excludeInternalUsers: true
    }
  },
  methods: {
    setDefaultValues: function () {
      if (!isEmpty(this.$store.state.selectedGroupCourseObj)) {
        this.selectedGroupCourseObj = this.$store.state.selectedGroupCourseObj
      }
      if (!isEmpty(this.$store.state.selectedCohortObj)) {
        this.selectedCohortObj = this.$store.state.selectedCohortObj
      }
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.selectedElementForProcessingValue.length > 0) {
        var objToProccess = {
          GroupId: this.selectedGroupCourseObj.GroupId,
          UserSubsetType: this.selectedUserSubset,
          ExcludeInternalUsers: this.getExcludeInternalUsersValue,
          GCCData: this.selectedElementForProcessing
        }
        this.$emit('selectedFilterValues', objToProccess)
        this.$store.state.selectedGroupCourseObj = this.selectedGroupCourseObj
        this.$store.state.selectedCohortObj = this.selectedCohortObj
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select all required inputs to export report.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupCourseObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupCourseObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupCourseObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupCourseObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupCourseObj.GroupName + ' :: ' + this.selectedGroupCourseObj.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    getAssociatedLessonAndElementList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupCourseObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        courseService
          .listLessonAndElements(
            storeObj.state.access_token,
            _this.selectedGroupCourseObj.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving lesson list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupCourseObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupCourseObj.CourseSubTitle + ']'
                this.errorMsg = 'No lessons found in \'' + this.selectedGroupCourseObj.CourseTitle + subTitleName + '\'.'
                this.selectedElementObj = -1
              }
              this.lessonList = responseObj.data
              this.setLessonDataToPass()
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select CourseMasterID is NULL hence declined LISTING Associated Lesson and element OPERATION'
        )
      }
    },
    setLessonDataToPass: function () {
      this.lessonDataToPass = []
      forEach(this.lessonList, (lessonObj) => {
        var objToPush = {
          name: lessonObj.Title,
          lessonObj: lessonObj
        }
        this.lessonDataToPass.push(objToPush)
      })
    },
    setElementDataToPass: function () {
      this.elementDataToPass = []
      forEach(this.selectedLessonForProcessing, (selectedObj) => {
        const lessonObj = selectedObj.lessonObj
        const elementList = lessonObj.ElementObj
        forEach(elementList, (elementObj) => {
          var objToPush = {
            name: lessonObj.Title + ' :: ' + elementObj.Title,
            GroupCourseMasterId: this.selectedGroupCourseObj.GroupCourseMasterId,
            CohortId: this.selectedCohortObj.CohortId,
            ModuleId: lessonObj.ModuleId,
            ElementId: elementObj.ElementId
          }
          this.elementDataToPass.push(objToPush)
        })
      })
    }
  },
  components: {
    'vue-multi-select': vueMultiSelect,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getLessonList: {
      get: function () {
        return this.lessonList
      }
    },
    getElementList: {
      get: function () {
        return this.elementList
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    },
    selectedLessonForProcessingValue: {
      get: function () {
        return this.selectedLessonForProcessing
      },
      set: function (newValue) {
        this.selectedLessonForProcessing = newValue
        this.setElementDataToPass()
      }
    },
    selectedElementForProcessingValue: {
      get: function () {
        return this.selectedElementForProcessing
      },
      set: function (newValue) {
        this.selectedElementForProcessing = newValue
      }
    },
    getExcludeInternalUsersValue: {
      get: function () {
        return this.excludeInternalUsers
      },
      set: function (newValue) {
        this.excludeInternalUsers = newValue
      }
    }
  },
  watch: {
    selectedGroupCourseObj: function (newValue, oldValue) {
      // AK: Reset Selected Cohort Obj to -1 again
      if (!isEqual(this.selectedGroupCourseObj, this.$store.state.selectedGroupCourseObj)) {
        this.selectedLessonForProcessingValue = []
        this.selectedElementForProcessingValue = []
        this.selectedCohortObj = -1
      }
      // this.selectedCohortObj = -1
      this.getAssociatedCohortList()
      this.getAssociatedLessonAndElementList()
    }
  },
  name: 'GroupCourseLessonElementFilterBar'
}
</script>

<style scoped>
#vueMultiSelect .select {
  width: 100%;
}
#vueMultiSelect button.btn-select {
  min-width: 100%;
}
#vueMultiSelect .select .checkboxLayer {
  width: 100%;
}
#vueMultiSelect .select .helperButton {
  width: 100px !important;
  color: #000;
}
#vueMultiSelect .select .helperButton:hover {
  background-color: #ffffff;
  color: #000;
}
#vueMultiSelect ul>li .margin-left-20 {
  background-color: #fff;
  word-wrap: break-word;
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-break: strict;
  hyphens: none;
  -webkit-hyphens: none;
  -moz-hyphens: none;
}
.GroupCourseLessonElementFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
.padding-left-1Perc {
  padding-left: 1% !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-4Perc {
  margin-top: 4%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width-15px{
  width: 15%;
}
.margin-left-4Perc{
  margin-left:4% !important;
}
.text-align-right{
  text-align: right;
}
.width-7Perc{
  width:7% !important;
}
.margin-left-1Point5Perc{
  margin-left: 1.5% !important;
}

.margin-bottom-4Perc{
  margin-bottom:4% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/elementwise_report/GroupCourseLessonElementFilterBar.vue